/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPermissionsResponse
 */
export interface UserPermissionsResponse {
    /**
     * resolved server-side: true if the current user may manage service agreements. Consumers must not recompute this from role information.
     * 
     * @type {boolean}
     * @memberof UserPermissionsResponse
     */
    canManageAgreements?: boolean;
}

/**
 * Check if a given object implements the UserPermissionsResponse interface.
 */
export function instanceOfUserPermissionsResponse(value: object): value is UserPermissionsResponse {
    return true;
}

export function UserPermissionsResponseFromJSON(json: any): UserPermissionsResponse {
    return UserPermissionsResponseFromJSONTyped(json, false);
}

export function UserPermissionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPermissionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'canManageAgreements': json['canManageAgreements'] == null ? undefined : json['canManageAgreements'],
    };
}

export function UserPermissionsResponseToJSON(json: any): UserPermissionsResponse {
    return UserPermissionsResponseToJSONTyped(json, false);
}

export function UserPermissionsResponseToJSONTyped(value?: UserPermissionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'canManageAgreements': value['canManageAgreements'],
    };
}

